<template>
	<section>
		<el-row>
			<el-col :span="24" class="toolbar">
				<!--工具条-->
				<el-row>
					<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
						<el-form :inline="true" :model="filters">
							<el-form-item>
								<el-select 
									v-model="filters.spcode" filterable placeholder="选择上游" class="h-m-select">
								  <el-option v-for="item in splist"
									:key="item.spcode" :label="`${(item.spcode)}:${(item.name)}`" v-model="item.spcode">
								  </el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-input v-model="filters.s_code" placeholder="业务编号" @keyup.enter.native="getLists"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="filters.code_name" placeholder="业务名称" @keyup.enter.native="getLists"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="handleAdd">新增</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<el-row>
					<!--列表-->
					<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<div>
									日限:<font v-if="scope.row.daylimit>0" color="red" size="4">{{scope.row.daylimit}}</font>
									<font v-else color="green" size="4">不限</font>
									<br/>
									<el-button type="text" size="small" @click="handleCopy(scope.$index, scope.row)">复制</el-button>
									<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
									<!-- <el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="" label="代码信息" min-width="280">
							<template slot-scope="scope">
								<font size="1">时间:{{scope.row.entime}}</font><br/>
								上游:<font color="green">{{scope.row.spcode}}:{{scope.row.spname}}</font>
								&nbsp;&nbsp;业务编号:<font color="green" size="4">{{scope.row.s_code}}</font>:{{scope.row.code_name}}<br/>
								<font size="1">资费:{{scope.row.fee*0.01}}元&nbsp;&nbsp;结算{{scope.row.jsdj*0.01}}元&nbsp;&nbsp;
								开通省份:{{scope.row.open_provids}}</font>
								<font v-if="scope.row.processmd=='2'">异步处理</font>
								<font v-else>同步处理</font>
								<br/>
								处理类:<font color="red">{{scope.row.process_class}}</font><br/>
								获取URL:<font color="blue">{{scope.row.get_code_url}}</font><br/>
								<font size="1">参数:<u>{{scope.row.get_code_param}}</u></font><br/>
								提交URL:<font color="blue">{{scope.row.do_submit_url}}</font><br/>
								<font size="1">参数:<u>{{scope.row.do_submit_param}}</u></font><br/>
								<font v-if="scope.row.do_argee_url!=''">同意:{{scope.row.do_argee_url}}<br/></font>
								参数:<font v-for="item in scope.row.param_conf"><el-tag>{{item.set}}</el-tag>&nbsp;&nbsp;</font>
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<el-row>
					<!--工具条翻页-->
					<el-col :span="24" class="toolbar">
						<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="editSubmit" :with-header="false"
		  size="50%"
		  direction="rtl">
			<!--编辑界面-->
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div>
						<el-button @click.native="editFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
								<el-form-item label="上游" prop="spcode">
									<el-select 
										v-model="editForm.spcode" filterable placeholder="选择上游" class="h-m-select">
									  <el-option v-for="item in splist"
										:key="item.spcode" :label="`${(item.spcode)}:${(item.name)}`" v-model="item.spcode">
									  </el-option>
									</el-select>
									系统变量:cpscode渠道业务代码/cporder渠道自定义订单/sporder 上游订单
								</el-form-item>
								<el-form-item label="业务编号" prop="s_code">
									<el-input v-model="editForm.s_code" :placeholder="copyscode" @blur="inputExtend"></el-input>
									<el-tag effect="dark" v-if="checkInSpService" type="danger">存在此代码请更改!</tag>
								</el-form-item>
								<el-form-item label="业务名称" prop="code_name">
									<el-input v-model="editForm.code_name" placeholder="业务名称"></el-input>
								</el-form-item>
								<el-form-item label="资费(分)" prop="fee">
									<el-input v-model="editForm.fee" placeholder="资费" width="100"></el-input>
								</el-form-item>
								<el-form-item label="结算(分)" prop="jsdj">
									<el-input v-model="editForm.jsdj" placeholder="结算" :width="100"></el-input>
								</el-form-item>
								<el-form-item label="日限">
									<el-input v-model="editForm.daylimit" placeholder="日限制" :width="100"></el-input>
								</el-form-item>
								<el-form-item label="开通省份">
									<el-input v-model="editForm.open_provids" placeholder="开通省份"></el-input>
								</el-form-item>
								<el-form-item label="处理类">
									<el-input v-model="editForm.process_class" placeholder="处理类"></el-input>
								</el-form-item>
								<el-form-item label="参数" prop="param_conf">
									<el-input v-model="editForm.param_conf" placeholder="参数" type="textarea" :autosize="{ minRows: 4, maxRows: 25}"></el-input>
								</el-form-item>
								<el-form-item label="返回对照表">
									<el-input v-model="editForm.sp_back_param" :autosize="{ minRows: 4, maxRows: 25}" placeholder="对照表" type="textarea"></el-input>
								</el-form-item>
								<el-form-item label="获取URL" prop="get_code_url">
									<el-input v-model="editForm.get_code_url" placeholder="获取URL" type="textarea" :row="25"></el-input>
								</el-form-item>
								<el-form-item label="获取URL参数">
									<el-input v-model="editForm.get_code_param" placeholder="获取URL参数" type="textarea" :autosize="{ minRows: 4, maxRows: 25}"></el-input>
								</el-form-item>
								<el-form-item label="提交URL" prop="do_submit_url">
									<el-input v-model="editForm.do_submit_url" placeholder="提交URL" type="textarea" :row="25"></el-input>
								</el-form-item>
								<el-form-item label="提交URL参数">
									<el-input v-model="editForm.do_submit_param" placeholder="提交URL参数" type="textarea" :autosize="{ minRows: 4, maxRows: 25}"></el-input>
								</el-form-item>
								<el-form-item label="同意URL">
									<el-input v-model="editForm.do_argee_url" placeholder="同意URL" type="textarea" :row="25"></el-input>
								</el-form-item>
								<el-form-item label="同意URL参数">
									<el-input v-model="editForm.do_argee_param" placeholder="同意URL参数" type="textarea" :row="25"></el-input>
								</el-form-item>
								<el-form-item label="备注">
									<el-input v-model="editForm.remark" placeholder="备注" type="textarea" :autosize="{ minRows: 4, maxRows: 25}"></el-input>
								</el-form-item>
								<el-form-item label="处理方式" prop="processmd">
									<el-select 
										v-model="editForm.processmd" filterable placeholder="选择处理方式" class="h-m-select">
									  <el-option value="1" label="同步处理"></el-option>
									  <el-option value="2" label="异步处理"></el-option>
									</el-select>
								</el-form-item>
							</div>
						</el-card>		
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					spcode:'',s_code:'',code_name:''
				},
				splist:[],
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				checkInSpService:false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					spcode :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					s_code :[
						{required: true,message: '业务编号不能为空!',trigger: 'blur'}
					],
					code_name :[
						{required: true,message: '业务名称不能为空!',trigger: 'blur'}
					],
					fee :[
						{required: true,message: '资费不能为空!',trigger: 'blur'}
					],
					open_provids :[
						{required: true,message: '开通省份不能为空!',trigger: 'blur'}
					],
					process_class :[
						{required: true,message: '处理类不能为空!',trigger: 'blur'}
					],
					fee:[
						{required: true,message: '资费不能为空!',trigger: 'blur'}
					],
					jsdj:[
						{required: true,message: '结算不能为空!',trigger: 'blur'}
					]
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',spcode:'',s_code:'',code_name:'',fee:'',jsdj:'',open_provids:'',process_class:'',param_conf:'',
					get_code_url:'',do_submit_url:'',do_argee_url:'',remark:'',do_argee_param:'',do_submit_param:'',get_code_param:'',sp_back_param:'',processmd:'',daylimit:'0'
				},
				copyscode:''
			}
		},
		methods: {
			inputExtend(){
				if(this.editForm.s_code=='') return ;
				this.editLoading = true ;
				//检测代码是否存在
				let para = {
					actionurl:'default/getListAll',
					s_code:this.editForm.s_code,
					checkId:this.editForm.id,
					sqlid:'sp_spConf.checkQuery'
				};
			
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						if(res.data.total>0) this.checkInSpService = true ;//存在
						else this.checkInSpService = false ;
					}
					this.editLoading = false;
				});
			},
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'sp_spinfo.query'
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					spcode:this.filters.spcode,
					s_code:this.filters.s_code,
					code_name:this.filters.code_name,
					sqlid:'sp_spConf.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.copyscode = '业务编码';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_spConf.add',entime:'',spcode:'',s_code:'',code_name:'',fee:'',jsdj:'',open_provids:'',process_class:'',param_conf:'',get_code_url:'',do_submit_url:'',do_argee_url:'',remark:'',do_argee_param:'',do_submit_param:'',get_code_param:'',sp_back_param:'',processmd:'',daylimit:'0'
				};
			},
			handleCopy:function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '复制';
				this.editForm = Object.assign({}, row);
				this.copyscode = row.s_code;
				this.editForm.s_code = '';
				this.editForm.param_conf = JSON.stringify(row.param_conf);
				try{
					let ss = JSON.stringify(row.get_code_param);
					if(ss.indexOf("{")>=0){
						this.editForm.get_code_param = JSON.stringify(row.get_code_param);
					}
				}catch(e){}
				try{
					let ss = JSON.stringify(row.do_submit_param);
					if(ss.indexOf("{")>=0){
						this.editForm.do_submit_param = JSON.stringify(row.do_submit_param);
					}
				}catch(e){}
				try{
					let ss = JSON.stringify(row.do_argee_param);
					if(ss.indexOf("{")>=0){
						this.editForm.do_argee_param = JSON.stringify(row.do_argee_param);
					}
				}catch(e){}
				this.editForm.id = '';
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'sp_spConf.add';
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.copyscode = '业务编码';
				this.editForm = Object.assign({}, row);
				this.editForm.param_conf = JSON.stringify(row.param_conf);
				try{
					let ss = JSON.stringify(row.get_code_param);
					if(ss.indexOf("{")>=0){
						this.editForm.get_code_param = JSON.stringify(row.get_code_param);
					}
				}catch(e){}
				try{
					let ss = JSON.stringify(row.do_submit_param);
					if(ss.indexOf("{")>=0){
						this.editForm.do_submit_param = JSON.stringify(row.do_submit_param);
					}
				}catch(e){}
				try{
					let ss = JSON.stringify(row.do_argee_param);
					if(ss.indexOf("{")>=0){
						this.editForm.do_argee_param = JSON.stringify(row.do_argee_param);
					}
				}catch(e){}
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'sp_spConf.upt';
			},
			editSubmit:function(){
				//检测代码是否存在
				if(this.checkInSpService) {
					this.$message({message: "代码重复，不可提交!",type: "error"});
					return ;
				}
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'sp_spConf.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getSpList();
			this.getLists();
		}
	}	
</script>
<style scoped>
	.el-header {
	  background-color: #FFFFFF;
	  //color: white;
	  text-align: left;
	  line-height: 60px;
	}
	 
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	}
</style>


// WEBPACK FOOTER //
// spConf.vue?0c6a7fba